import { createMutableAction } from '@bimser/core';
import * as ActionTypes from './actionTypes';

export function updateLoadingAction(payload: any) {
	return createMutableAction(
		ActionTypes.CHANGE_OBJECT_SELECT_POPOVER_LOADING_STATE_ACTION,
		payload
	);
}
